import initialState from './initialState';
import { FETCH_BATCHES, RECEIVE_BATCHES } from '../actions/actionTypes';

export default function batchesReducer(state = initialState.batches, action) {
    let newState = {};
    switch (action.type) {
        case FETCH_BATCHES:
            return { ...state, fetching: true };
        case RECEIVE_BATCHES:
			newState.items = action.batches.items;
			newState.pagination = action.batches.pagination;
			newState.search = action.batches.search;
			newState.customerId = action.batches.customerId;
            newState.settings = action.batches.settings;
            newState.fetching = false;
            return newState;
        default:
            return state;
    }
}